import React, { useState, useEffect } from "react";
import "./creditMange.css";

import {
    Box,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Collapse,
    TablePagination,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import { load } from "@cashfreepayments/cashfree-js";
import { Download } from 'lucide-react';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import toast from "react-hot-toast";
import { CreditInputType, DetailedTableData, MainTableData, UserListType } from "../ManageOrganization/Managecredits/manangeCreditType";
import { axiosInstance } from "../../utility/apiInstance";
import { useRole } from "../MangeContextProvide";
import DownloadReportModal from "../DownloadReport/DownloadReportModal";
import { downloadExcel } from "../../utility/downloadExcel";


export default function CrediManagment() {
    const { organizationId } = useRole() as any;
    const [expandedRow, setExpandedRow] = useState<string | null>(null);
    const [awbData, setAwbData] = useState<MainTableData[]>([]);
    const [detailedRowData, setDetailedRowData] = useState<{
        [key: string]: DetailedTableData[];
    }>({});
    const [availabeCreditValue, setAvaalableCreditValue] = useState(0);
    const [organizationName, setOrganizationName] = useState<String>("");
    const [currency, setCurrency] = useState<String>("");
    const [mainPage, setMainPage] = useState<number>(0);
    const [mainRowsPerPage, setMainRowsPerPage] = useState<number>(5);
    const [detailedPage, setDetailedPage] = useState<{ [key: string]: number }>(
        {}
    );
    const [creditInputValue, setCreditInput] = useState<CreditInputType>({
        creditValue: ""
    })
    const [modalOpen, setModalOpen] = useState(false);
    const [userLists, setUserList] = useState<UserListType[]>([]);
    const [creditError, setCreditError] = useState<String>("");
    const [detailedRowsPerPage] = useState<number>(5);

    const initializeSDK = async function () {
        return await load({
            mode: "sandbox",
        });
    };

    const verifyAndUpdateCreditValue = async (orderId: string): Promise<boolean> => {
        try {
            const { data } = await axiosInstance.get(`/api/v1/payment/verify-status/${orderId}`);

            return data.success;
        } catch (error) {
            return false;
        }
    };

    const handleDownloadReport = async (
        reportType: "summary" | "detail",
        { type, user, startDate, organizationId, endDate }: any
    ) => {
        const payload = {
            type,
            user: user === "All" ? undefined : user,
            startDate,
            endDate,
            organizationId: organizationId,
            reportType,
        };

        try {

            const response = await axiosInstance.post(`/api/v1/credit-transaction/download-transaction-report`, payload);

            if (response.data?.success && response.data.data.length > 0) {
                const fileName = `Transaction-${reportType}-Report-${new Date().toISOString().slice(0, 10)}`;
                downloadExcel(response.data.data, fileName, reportType);
                toast.success(response?.data?.message);
            } else {
                toast.error("No data to download");
            }
        } catch (err) {
            toast.error("Failed to download report");
        }
    };


    const handleUpdate = async () => {
        let cashfree = await initializeSDK();
        try {
            const payload = {
                amount: Number(creditInputValue.creditValue),
            };
            if (payload.amount > 0) {
                const { data } = await axiosInstance.post(
                    "/api/v1/payment/create",
                    payload
                );
                if (data.success) {

                    let checkoutOptions = {
                        paymentSessionId: data.data.payment_session_id
                        ,
                        redirectTarget: "_modal",
                    };
                    const order_id = data.data.order_id;
                    cashfree.checkout(checkoutOptions)
                        .then(async function (result: any) {
                            const isVerified = await verifyAndUpdateCreditValue(order_id);

                            if (isVerified) {
                                await getFieldData();
                                await getAwbData();
                                if (rowid) {
                                    await getDetailedData(rowid);
                                }

                                setCreditInput((preState) => ({ ...preState, creditValue: "" }));
                            }
                        })
                }

            }
            setCreditError("");
        } catch (err: any) {
            err = err.response.data.error;
            if (Array.isArray(err) && err.length > 0) {
                err = err[0].message;
            }

            toast.error(err);

        }
    };

    const getAwbData = async () => {
        try {
            const endpoint = `/api/v1/credit-transaction/transaction-history?organizationId=${organizationId}`;
            const response = await axiosInstance.get(endpoint);

            setAwbData(response.data.data);

        } catch (error) {

        }
    };


    const getOrganizationDetails = async () => {
        try {
            const endpoint = `/api/v1/organisation/getById/${organizationId}`;
            const { data } = await axiosInstance.get(endpoint);
            const organization = data.data;

            setOrganizationName(organization.organizationName);
            setCurrency(organization?.chargeRate?.currency||"")

        } catch (error) {

        }
    }

    const getFieldData = async () => {
        try {
            const endpoint = `/api/v1/credit-transaction/${organizationId}`;
            const response = await axiosInstance.get(endpoint);
            setAvaalableCreditValue(response.data.data.closingBalance);
        } catch (error) { }
    };



    const [rowid, setRowid] = useState("");
    const getDetailedData = async (rowId: string) => {
        setRowid(rowId);
        try {
            const response = await axiosInstance.get(`/api/v1/credit-transaction/transaction-history?organizationId=${organizationId}&date=${rowId}`);
            setDetailedRowData((prevData) => ({
                ...prevData,
                [rowId]: response.data.data,
            }));
        } catch (error) { }
    };
    useEffect(() => {
        getDetailedData(rowid);
    }, [rowid]);

    const getCustomerList = async () => {
        try {
            const endPoint = `/api/v1/credit-transaction/customer-list/${organizationId}`;
            const { data } = await axiosInstance.get(endPoint);
            let listOfUsers: UserListType[] = [{ label: "All", value: "All" }];
            const formattedUserList: UserListType[] = (data?.data || []).map((user: any) => ({
                label: user.name,
                value: user._id
            }));


            let finalUserList = [...listOfUsers, ...formattedUserList];

            setUserList(finalUserList);
        } catch (error) {
            setUserList([]);
        }
    };

    useEffect(() => {
        getAwbData();
        getFieldData();
        getOrganizationDetails();
        getCustomerList()

    }, []);

    const handleAccordionToggle = async (rowId: string) => {
        if (expandedRow === rowId) {
            setExpandedRow(null);
            return;
        }
        setExpandedRow(rowId);
        if (!detailedRowData[rowId]) {
            getDetailedData(rowId);
        }
    };



    const handleChangeDetailedPage =
        (rowId: string) => (event: unknown, newPage: number) => {
            setDetailedPage((prev) => ({
                ...prev,
                [rowId]: newPage,
            }));
        };

    const formatDateTime = (dateTimeString: string) => {
        const date = new Date(dateTimeString);
        return `${date.toLocaleDateString()} ${date.getHours()}:${date
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;
    };


    const handleCreditsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;


        if (!/^\d+(\.\d*)?$/.test(value) && value !== "") return;


        setCreditInput((prev) => ({ ...prev, creditValue: value }));


        if (value === "") {
            setCreditError("Credits must be greater than 0");
            return;
        }

        const numValue = parseFloat(value);


        if (!isNaN(numValue)) {
            if (numValue <= 0) {
                setCreditError("Credits must be greater than 0");
            } else {
                setCreditError("");
            }
        }
    };

    const renderCreditInfo = () => {
        return (
            <>
                <div className="old_dashboard_title">
                    <h1 className="text-2xl font-bold text-gray-700 mt-[-15px] mb-[10px]">Manage Credits</h1>
                </div>

                <div className="grid grid-cols-12 sm:grid-cols-12 lg:grid-cols-12 border rounded-md py-3 p-2 gap-x-1 gap-y-2 lg:p-4 bg-[#fdfdfd]">
                    <div className="col-span-12 sm:col-span-6 lg:col-span-6 mb-1 sm:mb-5">
                        <div className="flex profilenbox">
                            <figure className="bg-gray-50 w-[35px] h-[35px] rounded-full border border-gray-200 p-1 flex justify-center item-center center">
                                <CorporateFareOutlinedIcon className="text-gray-400" />
                            </figure>

                            <aside className="ml-4">
                                <label className="block text-base font-semibold">
                                    Organization Name
                                </label>
                                <TextField
                                    InputProps={{
                                        readOnly: true,
                                        sx: {
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#EDEBEB",
                                            },
                                            height: "0",
                                        },
                                    }}
                                    value={organizationName}
                                    placeholder="Organization name"
                                    sx={{ minWidth: "100%", maxWidth: "400px" }}
                                    fullWidth
                                />
                            </aside>
                        </div>
                    </div>

                    <div className="col-span-12 sm:col-span-6 lg:col-span-6 mb-5">
                        <div className="flex profilenbox">
                            <figure className="bg-gray-50 w-[35px] h-[35px] rounded-full border border-gray-200 p-1 flex justify-center item-center center">
                                <AccountBalanceWalletOutlinedIcon className="text-gray-400" />
                            </figure>

                            <aside className="ml-4">

                                <label className="block text-base">
                                    Credits Remaining
                                </label>
                                <TextField
                                    InputProps={{
                                        readOnly: true,
                                        sx: {
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#EDEBEB",
                                            },
                                            height: "",
                                        },
                                    }}
                                    value={currency + " " + availabeCreditValue}
                                    placeholder="Credits-Remaining"
                                    sx={{ minWidth: "100%", maxWidth: "400px" }}
                                    fullWidth
                                />
                            </aside>
                        </div>
                    </div>


                    <div className="col-span-12 2xl:col-span-12 xl:col-span-12 lg:col-span-12 md:col-span-12">

                        <div className="grid grid-cols-12 sm:grid-cols-12 lg:grid-cols-12  gap-x-2 gap-y-2">
                            <div className="col-span-12 lg:col-span-3 md:col-span-3 mangeinputBorder">
                                <TextField
                                    id="outlined-basic"
                                    label="Currency"
                                    variant="outlined"
                                    type="text"
                                    value={currency}
                                    disabled
                                />
                            </div>

                            <div className="col-span-12 lg:col-span-3 md:col-span-3 mangeinputBorder">
                                <TextField
                                    id="outlined-basic"
                                    label="Add Credits"
                                    variant="outlined"
                                    type="text"
                                    value={creditInputValue.creditValue}

                                    onChange={handleCreditsChange}
                                    error={!!creditError}
                                    helperText={creditError}
                                />
                            </div>

                            <div className="col-span-12 lg:col-span-6 md:col-span-6 mangeinputBorder">
                                <div className="w-full flex justify-between">
                                    <Button
                                        className="btnTheme proceedToAdd"
                                        variant="contained"
                                        onClick={handleUpdate}
                                        disabled={creditError.length > 0 || creditInputValue.creditValue.length <= 0}
                                    >
                                        Proceed to Add

                                    </Button>
                                    <Button className="btnTheme btndownloadPadding "
                                        onClick={() => setModalOpen(true)} variant="contained">
                                        <Download /> Download Report
                                    </Button>
                                </div>
                                <DownloadReportModal
                                    open={modalOpen}
                                    onClose={() => setModalOpen(false)}
                                    organizationId={organizationId}
                                    onDownload={handleDownloadReport}
                                    userLists={userLists}
                                />


                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const renderTable = () => {

        return (
            <div className="grid grid-cols-12 removeShadow">
                <TableContainer 
                    component={Paper}
                    className="tableCreditManagement col-span-12 border rounded-md"
                    style={{ borderColor: "#EDEBEB" }}
                >
                    <Table
                        className="33"
                        sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}
                    >
                        <TableHead>
                            <TableRow>
                                {[
                                    "Date",
                                    "Opening Credits",
                                    "Transaction",
                                    "Closing Credits",
                                    "Action",
                                ].map((header, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            fontSize: "1.125rem",
                                            textAlign: "center",
                                            color: "#ffb310",
                                            borderRight: index < 4 ? "1px solid #EDEBEB" : "none",
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {awbData &&
                                awbData
                                    .slice(
                                        mainPage * mainRowsPerPage,
                                        mainPage * mainRowsPerPage + mainRowsPerPage
                                    )
                                    .map((row: any) => (
                                        <React.Fragment key={row._id}>
                                            <TableRow>
                                                {[
                                                    "date",
                                                    "openingBalance",
                                                    "totalTransactionValue",
                                                    "closingBalance",
                                                ].map((key, index) => (
                                                    <TableCell
                                                        key={index}
                                                        sx={{
                                                            textAlign: "center",
                                                            borderTop: "1px solid #EDEBEB",
                                                            borderRight:
                                                                index < 3 ? "1px solid #EDEBEB" : "none",
                                                        }}
                                                    >
                                                        {key === "date" ? (
                                                            row[key]
                                                        ) : key === "openingBalance" || key === "totalTransactionValue" || key === "closingBalance" ? (
                                                            `${currency} ${(row[key] as number)?.toFixed(2)}`
                                                        ) : (
                                                            (row[key as keyof MainTableData] as number)?.toFixed(2)
                                                        )}
                                                    </TableCell>
                                                ))}
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        borderTop: "1px solid #EDEBEB",
                                                    }}
                                                >
                                                    <Button
                                                        onClick={() => handleAccordionToggle(row._id)}
                                                        aria-label={
                                                            expandedRow === row._id
                                                                ? "Hide details"
                                                                : "Show details"
                                                        }
                                                    >
                                                        {expandedRow === row._id ? (
                                                            <RemoveIcon />
                                                        ) : (
                                                            <AddCircleOutlineIcon
                                                                sx={{
                                                                    color: "white",
                                                                    fontSize: "1.5rem",
                                                                    backgroundColor: "primary.main",
                                                                    borderRadius: "50%",
                                                                }}
                                                            />
                                                        )}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell colSpan={5} sx={{ p: 0 }}>
                                                    <Collapse
                                                        in={expandedRow === row._id}
                                                        timeout="auto"
                                                        unmountOnExit
                                                    >
                                                        <Box sx={{ pt: 0, pb: 0 }}>
                                                            <TableContainer className="innerTable">
                                                                <Table size="small">
                                                                    <TableHead>
                                                                        <TableRow sx={{ bgcolor: "grey.600" }}>
                                                                            {[
                                                                                "Date & Time",
                                                                                "User",
                                                                                "Type",
                                                                                "Narration",
                                                                                "Opening Balance",
                                                                                "Transaction Value",
                                                                                "Closing Value",
                                                                            ].map((header, index) => (
                                                                                <TableCell
                                                                                    key={index}
                                                                                    sx={{
                                                                                        color: "white",
                                                                                        borderRight:
                                                                                            index < 5
                                                                                                ? "1px solid white"
                                                                                                : "none",
                                                                                    }}
                                                                                >
                                                                                    {header}
                                                                                </TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {(detailedRowData[row._id] || [])
                                                                            .slice(
                                                                                (detailedPage[row._id] || 0) *
                                                                                detailedRowsPerPage,
                                                                                (detailedPage[row._id] || 0) *
                                                                                detailedRowsPerPage +
                                                                                detailedRowsPerPage
                                                                            )
                                                                            .map((detail: any, detailIndex) => (
                                                                                <TableRow
                                                                                    key={detailIndex}
                                                                                    sx={{
                                                                                        bgcolor:
                                                                                            detailIndex % 2 === 0
                                                                                                ? "grey.100"
                                                                                                : "grey.200",
                                                                                    }}
                                                                                >
                                                                                    {[
                                                                                        formatDateTime(detail?.createdAt),
                                                                                        detail?.userId?.name ||
                                                                                        detail?.user?.name,
                                                                                        detail?.type || "",
                                                                                        detail?.narration,
                                                                                        detail?.openingBalance?.toFixed(2),
                                                                                        detail.transactionValue?.toFixed(2),
                                                                                        detail?.closingBalance?.toFixed(2),
                                                                                    ].map((value, index) => (
                                                                                        <TableCell
                                                                                            key={index}
                                                                                            sx={{
                                                                                                borderRight:
                                                                                                    index < 5
                                                                                                        ? "1px solid white"
                                                                                                        : "none",
                                                                                            }}
                                                                                        >
                                                                                            {value}
                                                                                        </TableCell>
                                                                                    ))}
                                                                                </TableRow>
                                                                            ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                            <TablePagination
                                                                component="div"
                                                                count={detailedRowData[row._id]?.length || 0}
                                                                page={detailedPage[row._id] || 0}
                                                                onPageChange={handleChangeDetailedPage(row._id)}
                                                                rowsPerPage={detailedRowsPerPage}
                                                                rowsPerPageOptions={[5]}
                                                                sx={{
                                                                    ".MuiTablePagination-toolbar": {
                                                                        minHeight: "52px",
                                                                        paddingTop: 0,
                                                                        paddingBottom: 0,
                                                                    },
                                                                    ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                                                                    {
                                                                        margin: 0,
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    };

    return (
        <>
            <div className="credit_container_outer_box">
                <div className="whiteBox">

                    <div className="grid grid-cols-12">
                        <div className="col-span-12 xl:col-span-8 lg:col-span-12 md:col-span-12 sm:col-span-12">

                            {renderCreditInfo()}
                        </div>

                        <div className="col-span-12 xl:col-span-4 lg:col-span-4 md:col-span-4 flex justify-center creditImg">
                            <img
                                src="/images/credit__img.png"
                                alt="Credit Illustration"
                                className="w-full max-w-[300px] lg:max-w-[404px] h-auto object-contain hidden lg:block"
                            />
                        </div>

                    </div>
                    <div className="grid grid-cols-12 gap-4 mt-4">
                        <div className="col-span-12">{renderTable()}</div>
                    </div>
                </div>
            </div>
        </>
    );
}
